import i18n from '@/plugins/i18n';

const databaseGraphs = () => ({
  slow: [
    {
      width: '48%',
      title: i18n.global.t('apm.slow-statements'),
      height: 350,
      entityType: 'Service',
      independentSelector: false,
      metricType: 'SAMPLED_RECORD',
      metricName: 'top_n_database_statement',
      queryMetricType: 'readSampledRecords',
      chartType: 'ChartSlow',
      parentService: true,
      sortOrder: 'DES',
      unit: 'ms',
      isDatabase: true,
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
  ],
  lineCharts: [
    // {
    //     width: '48%',
    //     title: 'All Database Loads',
    //     height: 350,
    //     entityType: 'Service',
    //     independentSelector: false,
    //     metricType: 'REGULAR_VALUE',
    //     metricName: 'database_access_cpm',
    //     queryMetricType: 'sortMetrics',
    //     chartType: 'ChartSlow',
    //     parentService: false,
    //     sortOrder: 'DES',
    //     unit: 'CPM - calls per minute',
    //     isDatabase: true,
    //     labels: {
    //         xAxis: i18n.global.t('time'),
    //         yAxis: 'CPM'
    //     }
    // },
    // {
    //     width: 3,
    //     title: 'All Database Loads',
    //     height: 350,
    //     entityType: 'Service',
    //     independentSelector: false,
    //     metricType: 'REGULAR_VALUE',
    //     metricName: 'database_access_cpm',
    //     queryMetricType: 'sortMetrics',
    //     chartType: 'ChartSlow',
    //     parentService: false,
    //     sortOrder: 'DES',
    //     unit: 'CPM - calls per minute',
    //     isDatabase: true,
    //     labels: {
    //       xAxis: i18n.global.t('time'),
    //       yAxis: 'CPM'
    //     }
    //   },
    // {
    //     width: '48%',
    //     title: 'Database Avg Response Time',
    //     height: '15.625em',
    //     entityType: 'Service',
    //     independentSelector: false,
    //     metricType: 'REGULAR_VALUE',
    //     metricName: 'database_access_resp_time',
    //     queryMetricType: 'readMetricsValues',
    //     chartType: 'ChartLine',
    //     unit: 'ms',
    //     isDatabase: true,
    //     labels: {
    //         xAxis: i18n.global.t('time'),
    //         yAxis: 'ms'

    //     }
    // },

    // {
    //     width: '48%',
    //     title: 'Database Access Latency Percentile',
    //     height: '15.625em',
    //     entityType: 'Service',
    //     independentSelector: false,
    //     metricType: 'LABELED_VALUE',
    //     metricName: 'database_access_percentile',
    //     queryMetricType: 'readLabeledMetricsValues',
    //     chartType: 'ChartLine',
    //     metricLabels: 'P50, P75, P90, P95, P99',
    //     labelsIndex: '0, 1, 2, 3, 4',
    //     unit: 'ms',
    //     isDatabase: true,
    //     labels: {
    //       xAxis: i18n.global.t('time'),
    //       yAxis: 'ms'
    //     }
    // },
    //   {
    //     width: '48%',
    //     title: 'Database Access Successful Rate',
    //     height: '15.625em',
    //     entityType: 'Service',
    //     independentSelector: false,
    //     metricType: 'REGULAR_VALUE',
    //     metricName: 'database_access_sla',
    //     queryMetricType: 'readMetricsValues',
    //     chartType: 'ChartLine',
    //     unit: '%',
    //     aggregation: '/',
    //     aggregationNum: '100',
    //     isDatabase: true,
    //     labels: {
    //       xAxis: i18n.global.t('time'),
    //       yAxis: '%'
    //     }
    //   },
    //   {
    //     width: '48%',
    //     title: 'Database Traffic',
    //     height: '15.625em',
    //     entityType: 'Service',
    //     independentSelector: false,
    //     metricType: 'REGULAR_VALUE',
    //     metricName: 'database_access_cpm',
    //     queryMetricType: 'readMetricsValues',
    //     chartType: 'ChartLine',
    //     unit: 'CPM - calls per minute',
    //     isDatabase: true,
    //     labels: {
    //       xAxis: i18n.global.t('time'),
    //       yAxis: 'CPM'
    //     }
    //   },

    //   {
    //     width: '48%',
    //     title: 'Slow Statements',
    //     height: 350,
    //     entityType: 'Service',
    //     independentSelector: false,
    //     metricType: 'SAMPLED_RECORD',
    //     metricName: 'top_n_database_statement',
    //     queryMetricType: 'readSampledRecords',
    //     chartType: 'ChartSlow',
    //     parentService: true,
    //     sortOrder: 'DES',
    //     unit: 'ms',
    //     isDatabase: true,
    //     labels: {
    //       xAxis: i18n.global.t('time'),
    //       yAxis: 'ms'
    //     }
    //   },
    //   {
    //     width: '48%',
    //     title: 'All Database Loads',
    //     height: 350,
    //     entityType: 'Service',
    //     independentSelector: false,
    //     metricType: 'REGULAR_VALUE',
    //     metricName: 'database_access_cpm',
    //     queryMetricType: 'sortMetrics',
    //     chartType: 'ChartSlow',
    //     parentService: false,
    //     sortOrder: 'DES',
    //     unit: 'CPM - calls per minute',
    //     isDatabase: true,
    //     labels: {
    //       xAxis: i18n.global.t('time'),
    //       yAxis: 'CPM'
    //     }
    //   },
    //   {
    //     width: '48%',
    //     title: 'Un-Health Databases (Successful Rate)',
    //     height: 350,
    //     entityType: 'Service',
    //     independentSelector: false,
    //     metricType: 'REGULAR_VALUE',
    //     metricName: 'database_access_sla',
    //     queryMetricType: 'sortMetrics',
    //     chartType: 'ChartSlow',
    //     parentService: false,
    //     sortOrder: 'ASC',
    //     unit: '%',
    //     aggregation: '/',
    //     aggregationNum: '100',
    //     isDatabase: true,
    //     labels: {
    //       xAxis: i18n.global.t('time'),
    //       yAxis: '%'
    //     }
    //   },
    {
      width: '48%',
      title: i18n.global.t('apm.all-database-load'),
      isDatabase: true,
      header: {
        title: i18n.global.t('loadTitle'),
        titleIcon: '',
        content: [],
        displayCustomButton: false,
        customButtonProp: {
          title: '',
        },
      },

      chartColor: ['#008FFB'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'database_access_tc',
      queryMetricType: 'readMetricsValues',
      childQueries: [
        {
          entityType: 'Service',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'database_access_cpm',
          queryMetricType: 'readMetricsTotalValue',
          name: 'total',
        },
        {
          entityType: 'Service',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'database_access_cpm',
          queryMetricType: 'readMetricsValue',
          name: 'pm',
        },
      ],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('cpmWithFullForm'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfCalls'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },

    {
      width: '48%',
      title: i18n.global.t('errorTitle'),
      isDatabase: true,
      header: {
        title: i18n.global.t('accessErrorTitle'),
        titleIcon: 'error',
        content: [],
        isError: true,
        displayCustomButton: false,
        customButtonProp: {
          title: i18n.global.t('apm.error-traces'),
        },
      },
      chartColor: ['#FF8022'],
      height: '12.5em',
      entityType: 'Database',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'database_access_ec',
      queryMetricType: 'readMetricsValues',
      childQueries: [
        {
          entityType: 'Database',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'database_access_error_percent',
          queryMetricType: 'readMetricsValue',
          name: 'percentage',
        },
        {
          entityType: 'Database',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'database_access_epm',
          queryMetricType: 'readMetricsTotalValue',
          name: 'total',
        },
        {
          entityType: 'Database',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'database_access_epm',
          queryMetricType: 'readMetricsValue',
          name: 'pm',
        },
      ],
      chartType: 'ApexChartLine',
      unit: 'No',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfErrors'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
    {
      // width: '48%',
      // title: 'Database Avg Response Time',
      // height: '15.625em',
      // entityType: 'Service',
      // independentSelector: false,
      // metricType: 'REGULAR_VALUE',
      // metricName: 'database_access_resp_time',
      // queryMetricType: 'readMetricsValues',
      // chartType: 'ChartLine',
      // unit: 'ms',
      // isDatabase: true,
      // labels: {
      //     xAxis: i18n.global.t('time'),
      //     yAxis: 'ms'

      // }
      isDatabase: true,

      width: '48%',
      title: i18n.global.t('apm.endpoint-successful-rate'),
      header: {
        title: i18n.global.t('responseTimeWithoutUnit'),
        titleIcon: 'responseTime',
        content: [],
        displayOnlyUnit: true,
        displayCustomButton: false,
        customButtonProp: {
          title: i18n.global.t('apm.slow-traces'),
        },
      },
      chartColor: ['#98ED78'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'database_access_resp_time',
      queryMetricType: 'readMetricsValues',
      childQueries: [
        {
          entityType: 'Service',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'database_access_resp_time',
          queryMetricType: 'readMetricsValue',
          name: 'total',
        },
      ],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('ms-average'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('responseTimeWithUnit'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
      compareTrend: true,
    },
  ],
  areaCharts: [
    {
      isDatabase: true,
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('apm.database-access-latency-percentile'),
      height: '12.5em',
      header: {
        title: i18n.global.t('percentileResponseTimeTitle'),
        titleIcon: '',
        content: [],
        toolbar: true,
        HideCenterMiscContent: true,
      },
      chartColor: ['#5CA8FF', '#0DCEBF', '#FFCC55', '#A0A7E6', '#EA7699'],
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'database_access_percentile',
      queryMetricType: 'readLabeledMetricsValues',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'ms',
      metricLabels: 'P50, P75, P90, P95, P99',
      labelsIndex: '0, 1, 2, 3, 4',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('percentileUnit'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
  ],
});

export default databaseGraphs;
